import styled from 'styled-components/macro'

export const ButtonS = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`
